export default class UpdateAttachmentCommentRequest {
    public id: string = "";
    public comment: string = "";

    public readonly isUpdateAttachmentCommentRequest: boolean = true;
}